import { CodeInputs } from '@libs/components';

export default CodeInputs;
